function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "linkedin_square",
  "data-name": "linkedin square",
  d: "M27.532,0H1.633A1.576,1.576,0,0,0,.475.475,1.576,1.576,0,0,0,0,1.633v25.9A1.576,1.576,0,0,0,.475,28.69a1.576,1.576,0,0,0,1.158.475h25.9a1.621,1.621,0,0,0,1.633-1.633V1.633A1.576,1.576,0,0,0,28.69.475,1.576,1.576,0,0,0,27.532,0ZM8.658,24.835H4.329v-13.9H8.658ZM6.494,9.038A2.393,2.393,0,0,1,4.709,8.3a2.443,2.443,0,0,1-.722-1.766A2.465,2.465,0,0,1,6.494,4.025a2.443,2.443,0,0,1,1.766.722A2.393,2.393,0,0,1,9,6.532,2.411,2.411,0,0,1,8.259,8.3,2.411,2.411,0,0,1,6.494,9.038Zm18.342,15.8H20.544V18.076a10.218,10.218,0,0,0-.3-2.449q-.3-1.234-1.975-1.234a2.036,2.036,0,0,0-2.127,1.1,6.4,6.4,0,0,0-.456,2.468v6.873H11.354v-13.9h4.139v1.9h.076A4.169,4.169,0,0,1,17.032,11.3a4.63,4.63,0,0,1,2.639-.7q3.266,0,4.215,1.9a10.471,10.471,0,0,1,.949,4.709Z",
  fill: "#cc9c4e"
});

function SvgSocialLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.165,
    height: 29.165,
    viewBox: "0 0 29.165 29.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.7b03fbe9.svg";
export { ForwardRef as ReactComponent };